import { render } from "./HeadSorting.vue?vue&type=template&id=3d95dac3&scoped=true"
import script from "./HeadSorting.vue?vue&type=script&lang=js"
export * from "./HeadSorting.vue?vue&type=script&lang=js"

import "./HeadSorting.vue?vue&type=style&index=0&id=3d95dac3&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d95dac3"]])

export default __exports__